import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Box, Grid, Paper, Typography } from "@mui/material";

import useTheme from "../../hooks/useTheme";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import NavbarLanguagesDropdown from "../../components/navbar/NavbarLanguagesDropdown";

const Wrapper = styled(Paper)`
  padding: 0;
  margin: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => props.theme.sidebar.header.background};
`;

function SignUp() {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <Wrapper>
      <Helmet title={t("Sign Up")!} />

      {/* <SignUpComponent /> */}

      <Grid container height="100%" width="100%">
        <Grid
          size={{ sm: 12, md: 6, lg: 8 }}
          sx={{
            // hide on small screens
            display: { xs: "none", sm: "none", md: "block", lg: "block" },
          }}
        >
          <Box
            sx={{
              backgroundImage: `url("/static/img/backgrounds/2.jpg")`,
              height: "100%",
              width: "100%",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          />
        </Grid>

        <Grid
          size={{ sm: 12, md: 6, lg: 4 }}
          sx={{
            backgroundColor: "background.paper",
            alignContent: "center",
          }}
          py={(theme) => theme.spacing(10)}
          px={(theme) => theme.spacing(20)}
        >
          <Grid
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={3}
          >
            <img
              src="/static/img/logo/horizontal_logo.svg"
              style={{
                maxHeight: "60px",
              }}
            />

            <div
              data-o-auth="1"
              data-widget-mode="register"
              data-plan-uid="pWrY809n"
              data-plan-payment-term="month"
              data-skip-plan-options="true"
              data-mode="embed"
              style={{ width: "100%", height: "100%" }}
            ></div>

            <div>
              <Typography variant="body2" align="center" mt={2}>
                {t("Already have an account?")}&nbsp;
                <Link to="/auth/sign-in">{t("Sign in")}</Link>
              </Typography>
            </div>

            <NavbarLanguagesDropdown />
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default SignUp;
